import type { LocationCardState } from '../reducers/state';
import { EchoSmsRecipient, EchoEmailRecipient } from './rain-alert/models';

export type InstallationConfigState = Pick<LocationCardState<unknown>, 'settings' | 'locationDetails' | 'customer'>;

export enum CommonSectionIds {
    BasicInfo = 'basic-info-section',
    ConfigureAlarms = 'alarms-config-section',
    DataDelivery = 'data-delivery-section',
    DialogActions = 'dialog-actions-section',
    Advanced = 'advanced-section',
}

export enum BasicInfoCommonFieldIds {
    LocationName = 'basic-info-locationName',
    Series = 'basic-info-series',
    SerialNumber = 'basic-info-serialnumber',
    StatusSection = 'basic-info-status-section',
    Status = 'basic-info-status',
    MaintenanceInterval = 'basic-info-maintenanceInterval',
    MaintenanceEnd = 'basic-info-maintenanceEnd',
    CommunicationType = 'basic-info-communicationType',
    IpAddress = 'basic-info-ipaddress',
    ApnProvider = 'basic-info-apnProvider',
    ApnProviderBtn = 'basic-info-apnProviderBtn',
    Description = 'basic-info-description',
    AssignedRainGauge = 'basic-info-assignedRainGauge',
    ManholeDepth = 'basic-info-manholedepth',
    ManholeAddress = 'basic-info-manholeaddress',
    CoordinatesSection = 'basic-info-coordinates-section',
    Latitude = 'basic-info-latitude',
    Longitude = 'basic-info-longitude',
    SampleRate = 'basic-info-samplerate',
    FastRate = 'basic-info-fastrate',
    ScanRate = 'basic-info-scanRate',
    SyncTime = 'basic-info-synctime',
    UseDaylightSaving = 'basic-info-usedaylightsaving',
    InstallationDate = 'basic-info-installationDate',
    InstallationType = 'basic-info-installationType',
    InstallationShapeType = 'basic-info-installationShapeType',
    QFinalEntityID = 'basic-info-qFinalEntityID',
    CustomPropertiesSection = 'basic-info-custom-properties-section',
    CustomPropertyKey = 'basic-info-custom-property-key',
    CustomPropertyValue = 'basic-info-custom-property-value',
}

export enum ConfigureAlarmsFieldId {
    LowLevelEnable = 'alarms-lowLevelEnable',
    LowLevelThreshold = 'alarms-lowLevelThreshold',
    FullPipeEnable = 'alarms-fullPipeEnable',
    FullPipeThreshold = 'alarms-fullPipethreshold',
    HighLevelEnable = 'alarms-highLevelEnable',
    HighLevelThreshold = 'alarms-highLevelThreshold',
    HighHighEnable = 'alarms-highHighEnable',
    HighHighThreshold = 'alarms-highHighThreshold',
    HighFlowEnable = 'alarms-highFlowEnable',
    HighFlowThreshold = 'alarms-highFlowThreshold',
    OverflowEnable = 'alarms-overflowEnable',
    BatteryLowEnable = 'alarms-batteryLowEnable',
    BatteryLowThreshold = 'alarms-batteryLowThreshold',
    FlowLossAlarm = 'alarms-flowLossAlarm',
    FlowLossType = 'alarms-flowLossType',
    Percent = 'alarms-percent',
    Sensitivity = 'alarms-sensitivity',
    ClearPatternHistory = 'alarms-clearPatternHistory',
}

export enum DataDeliveryFieldId {
    PrismDeliveryIPAddress = 'data-delivery-prismdeliveryipaddress',
    PrismDeliveryNormal = 'data-delivery-prismdeliverynormal',
    PrismDeliveryFast = 'data-delivery-prismdeliveryfast',
}

export enum DialogActionsFieldId {
    ActivateButton = 'actions-activateButton',
    LocationDashboardButton = 'actions-locationDashboardButton',
    DiagnosticsButton = 'actions-diagnosticsButton',
    CollectButton = 'actions-collectButton',
    ScheduleCollect = 'actions-scheduleCollect',
    ExportBUtton = 'actions-exportButton',
    CancelButton = 'actions-cancelButton',
    SaveButton = 'actions-saveButton',
}

export enum SensorTypes {
    flex = 'flex-sensor',
    triton = 'triton-sensor',
}

export type TAssembledCustomProperty = { key: string; value: string };
export type TAssembledSilt = number[];
export type TAssembledSmsRecipients = EchoSmsRecipient[];
export type TAssembledEmailRecipients = EchoEmailRecipient[];
export type TAssembledApiData = number | string | boolean | null | Date | TAssembledCustomProperty[] | TAssembledSilt | TAssembledSmsRecipients | TAssembledEmailRecipients;

export enum AdvancedFieldId {
    CheckInEnable = 'advanced-checkInEnable',
    CheckInHour = 'advanced-checkInHour',
    SmsRecipients = 'advanced-smsrecipients',
    CheckInTextRecipient1 = 'advanced-checkInText-Recipient1',
    CheckInTextRecipient2 = 'advanced-checkInText-Recipient2',
    CheckInTextRecipient3 = 'advanced-checkInText-Recipient3',
    CheckInTextRecipient4 = 'advanced-checkInText-Recipient4',
    CheckInTextRecipient5 = 'advanced-checkInText-Recipient5',
    CheckInTextRec1StartHour = 'advanced-checkInText-Rec1-StartHour',
    CheckInTextRec1EndHour = 'advanced-checkInText-Rec1-EndHour',
    CheckInTextRec2StartHour = 'advanced-checkInText-Rec2-StartHour',
    CheckInTextRec2EndHour = 'advanced-checkInText-Rec2-EndHour',
    CheckInTextRec3StartHour = 'advanced-checkInText-Rec3-StartHour',
    CheckInTextRec3EndHour = 'advanced-checkInText-Rec3-EndHour',
    CheckInTextRec4StartHour = 'advanced-checkInText-Rec4-StartHour',
    CheckInTextRec4EndHour = 'advanced-checkInText-Rec4-EndHour',
    CheckInTextRec5StartHour = 'advanced-checkInText-Rec5-StartHour',
    CheckInTextRec5EndHour = 'advanced-checkInText-Rec5-EndHour',
    CheckInEmailRecipient1 ='advanced-checkInEmail-Recipient1',
    CheckInEmailRecipient2 ='advanced-checkInEmail-Recipient2',
    CheckInEmailRecipient3 ='advanced-checkInEmail-Recipient3',
    CheckInEmailRecipient4 ='advanced-checkInEmail-Recipient4',
    CheckInEmailRecipient5 ='advanced-checkInEmail-Recipient5',
}

export interface CheckInHourOption {
    value: number;
    text: string;
}

export const DEFAULT_CHECK_IN_TEXT_RECIPIENT_END_HOUR = 23;

export const InstallationTypeSectionIds = {
    Pipe: 'pipe-installation-config',
    Flume: 'flume-installation-config',
    Weir: 'weir-installation-config',
    Channel: 'channel-installation-config',
    Elevation: 'elevation-installation-config',
};

export enum PipeInstallationFieldIds {
    Height = 'pipe-height',
    Width = 'pipe-width',
    Hc = 'pipe-hc',
    Slope = 'pipe-slope',
    Roughness = 'pipe-roughness',
    EffectiveRoughness = 'pipe-effective-roughness',

    // static fields
    FrictionFactor = 'pipe-friction-factor',
    NominalDiameter = 'pipe-nominal-diameter',
    StartDate = 'pipe-start-date',
}

export enum ChannelInstallationFieldIds {
    Range = 'channel-range',
    NumberOfEntries = 'channel-numberOfEntries',
    EntriesSection = 'channel-entries-section',
    Depth = 'channel-depth',
    Quantity = 'channel-quantity',

    // array section
    ArraySection = 'channel-array-section',
}

export enum WeirInstallationFieldIds {
    Range = 'weir-range',
    Capacity = 'weir-capacity',
    Height = 'weir-height',
    Coefficient = 'weir-coefficient',
    Length = 'weir-length',
    Breadth = 'weir-breadth',
}

export enum FlumeInstallationFieldIds {
    Range = 'flume-range',
    Capacity = 'flume-capacity',
    Width = 'flume-width',
}

export enum PipeInstallationMp2FieldIds {
    Height = 'pipe-height-mp2',
    Width = 'pipe-width-mp2',
    Hc = 'pipe-hc-mp2',
    Slope = 'pipe-slope-mp2',
    Roughness = 'pipe-roughness-mp2',
    EffectiveRoughness = 'pipe-effective-roughness-mp2',

    // static fields
    FrictionFactor = 'pipe-friction-factor-mp2',
    NominalDiameter = 'pipe-nominal-diameter-mp2',
    StartDate = 'pipe-start-date-mp2',
}

export enum ChannelInstallationMp2FieldIds {
    Range = 'channel-range-mp2',
    NumberOfEntries = 'channel-numberOfEntries-mp2',
    EntriesSection = 'channel-entries-section-mp2',
    Depth = 'channel-depth-mp2',
    Quantity = 'channel-quantity-mp2',

    // array section
    ArraySection = 'channel-array-section-mp2',
}

export enum WeirInstallationMp2FieldIds {
    Range = 'weir-range-mp2',
    Capacity = 'weir-capacity-mp2',
    Height = 'weir-height-mp2',
    Coefficient = 'weir-coefficient-mp2',
    Length = 'weir-length-mp2',
    Breadth = 'weir-breadth-mp2',
}

export enum FlumeInstallationMp2FieldIds {
    Range = 'flume-range-mp2',
    Capacity = 'flume-capacity-mp2',
    Width = 'flume-width-mp2',
}
